<template lang="pug">
  .b-layout-controls
    button.b-button(
      type="button"
      @click="showJSON = true"
    ) JSON
    button.b-button(
      type="button"
      @click="reset"
    ) Reset
    ScaleButtons
</template>

<script>
import ScaleButtons from '@/components/controls/ScaleButtons';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'Controls',
  components: {
    ScaleButtons,
  },
  computed: {
    ...mapFields('showJSON', [
      'showJSON',
    ]),
  },
  methods: {
    ...mapActions('nodes', [
      'reset',
    ]),
  },
};
</script>
